var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainScore8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.522,
    height: 80.525,
    viewBox: "0 0 80.522 80.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-painscore8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M456.234-30.237A39.261,39.261,0,0,1,416.972,9.025a39.26,39.26,0,0,1-39.26-39.262A39.26,39.26,0,0,1,416.972-69.5a39.261,39.261,0,0,1,39.262,39.263",
    transform: "translate(-377.712 69.5)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-painscore8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M410.83-43.163a6.765,6.765,0,0,0,6.764,6.763,6.765,6.765,0,0,0,6.765-6.763,6.765,6.765,0,0,0-6.765-6.763,6.765,6.765,0,0,0-6.764,6.763",
    transform: "translate(-410.83 49.927)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3-painscore8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M411.759-43.553a6.765,6.765,0,0,1-6.764,6.764,6.764,6.764,0,0,1-6.763-6.764,6.763,6.763,0,0,1,6.763-6.762,6.764,6.764,0,0,1,6.764,6.762",
    transform: "translate(-398.232 50.315)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4-painscore8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M403.454-43.858a2.531,2.531,0,0,0,2.53,2.534,2.535,2.535,0,0,0,2.536-2.534,2.534,2.534,0,0,0-2.536-2.533,2.531,2.531,0,0,0-2.53,2.533",
    transform: "translate(-403.454 46.391)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5-painscore8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    d: "M404.749-44.058a1.036,1.036,0,0,0,1.035,1.037,1.039,1.039,0,0,0,1.041-1.037,1.039,1.039,0,0,0-1.041-1.037,1.036,1.036,0,0,0-1.035,1.037",
    transform: "translate(-404.749 45.095)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6-painscore8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M412.681-44.169a2.532,2.532,0,0,0,2.531,2.534,2.534,2.534,0,0,0,2.536-2.534,2.534,2.534,0,0,0-2.536-2.533,2.532,2.532,0,0,0-2.531,2.533",
    transform: "translate(-412.681 46.702)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7-painscore8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    d: "M413.978-44.37a1.035,1.035,0,0,0,1.034,1.037,1.037,1.037,0,0,0,1.04-1.037,1.036,1.036,0,0,0-1.04-1.035,1.034,1.034,0,0,0-1.034,1.035",
    transform: "translate(-413.978 45.405)",
    fill: "#00142e",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pain_8",
    "data-name": "Pain 8",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3725",
    "data-name": "Group 3725",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-painscore8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M376.712-70.5h80.83V10.334h-80.83Z",
    transform: "translate(-377.866 69.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3727",
    "data-name": "Group 3727",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M78.522,39.263A39.261,39.261,0,1,1,39.26,0,39.261,39.261,0,0,1,78.522,39.263Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3729",
    "data-name": "Group 3729",
    transform: "translate(38.228 22.594)",
    clipPath: "url(#clip-path-2-painscore8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M409.83-50.927h15.838v15.835H409.83Z",
    transform: "translate(-410.984 49.772)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3731",
    "data-name": "Group 3731",
    transform: "translate(38.229 22.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M0,6.763A6.765,6.765,0,1,0,6.764,0,6.765,6.765,0,0,0,0,6.763Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3733",
    "data-name": "Group 3733",
    transform: "translate(23.686 22.146)",
    clipPath: "url(#clip-path-3-painscore8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M397.232-51.315h15.836V-35.48H397.232Z",
    transform: "translate(-398.386 50.16)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735",
    transform: "translate(23.686 22.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M13.528,6.762A6.764,6.764,0,1,1,6.763,0,6.765,6.765,0,0,1,13.528,6.762Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810",
    transform: "translate(29.714 26.675)",
    clipPath: "url(#clip-path-4-painscore8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M402.454-47.391h7.375v7.375h-7.375Z",
    transform: "translate(-403.608 46.237)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812",
    transform: "translate(31.209 28.171)",
    clipPath: "url(#clip-path-5-painscore8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M403.749-46.1h4.385v4.382h-4.385Z",
    transform: "translate(-404.903 44.941)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814",
    transform: "translate(40.366 26.316)",
    clipPath: "url(#clip-path-6-painscore8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M411.681-47.7h7.376v7.375h-7.376Z",
    transform: "translate(-412.836 46.548)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816",
    transform: "translate(41.863 27.813)",
    clipPath: "url(#clip-path-7-painscore8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M412.978-46.4h4.383v4.381h-4.383Z",
    transform: "translate(-414.132 45.251)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838",
    transform: "translate(40.142 24.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M0,0S5.66,1.446,9.162,9.166",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839",
    transform: "translate(25.704 24.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M9.893,0S3.689,1.3,0,9.2",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840",
    transform: "translate(14.093 12.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M14,0S12.128,10.548,0,15.578",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841",
    transform: "translate(48.998 13.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M0,0A17.862,17.862,0,0,0,11.24,12.423",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842",
    transform: "translate(29.61 41.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M.062,0c-.1.392-.4,3.054,2.268,3.253s2.466-.492,3.351,0a3.471,3.471,0,0,0,3.256-.1,5.959,5.959,0,0,1,3.449-.888c1.873,0,2.662.1,2.859-1.675",
    transform: "translate(0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843",
    transform: "translate(25.039 52.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M0,10.956S1.281,4.25,3.453,2.082,11.14.11,15.084.012s8.773.4,11.139,2.858,5.325,7.4,6.114,7.988",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainScore8);
export default __webpack_public_path__ + "static/media/pain_score_8.0195813e.svg";
export { ForwardRef as ReactComponent };